module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop-4098c5773e003e9355e01456a134203c.jpg";